import {useEffect, useState} from "react";

export const useArticleSections = (ref, html) => {
  const [items, setItems] = useState([]);
  
  useEffect(() => {
    if (ref.current && html) {
      const elements = ref.current.querySelectorAll("[id][title]");
      const list = [...elements].map((e) => ({
        label: e.title,
        link: `#${e.id}`,
      }));
      setItems(list);
    }
  }, [ref, html]);
  
  return items;
};
